import { render } from "./CreateDepartment.vue?vue&type=template&id=f9b067e0&scoped=true"
import script from "./CreateDepartment.vue?vue&type=script&lang=js"
export * from "./CreateDepartment.vue?vue&type=script&lang=js"

import "./CreateDepartment.vue?vue&type=style&index=0&id=f9b067e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b067e0"]])

export default __exports__